import { render, staticRenderFns } from "./KanbanColumnModal.vue?vue&type=template&id=0c924c41&scoped=true"
import script from "./KanbanColumnModal.vue?vue&type=script&lang=js"
export * from "./KanbanColumnModal.vue?vue&type=script&lang=js"
import style0 from "./KanbanColumnModal.vue?vue&type=style&index=0&id=0c924c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c924c41",
  null
  
)

export default component.exports